import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-538572e8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tab-container" }
const _hoisted_2 = {
  key: 0,
  class: "tab-fields"
}
const _hoisted_3 = { class: "form-grid" }
const _hoisted_4 = {
  key: 0,
  class: "tab-fields"
}
const _hoisted_5 = { class: "form-grid" }
const _hoisted_6 = { class: "group-box" }
const _hoisted_7 = { class: "group-content" }
const _hoisted_8 = { class: "column-grid" }
const _hoisted_9 = { class: "group-box" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "group-header" }, "Photo", -1))
const _hoisted_11 = { class: "group-content" }
const _hoisted_12 = { class: "upload-image-section" }
const _hoisted_13 = { class: "picture-container" }
const _hoisted_14 = {
  key: 0,
  class: "displayed-file"
}
const _hoisted_15 = ["src"]
const _hoisted_16 = {
  key: 1,
  class: "fa-regular fa-image awaiting-news-image"
}
const _hoisted_17 = { class: "upload-button-disclaimer-container" }
const _hoisted_18 = { class: "group-box" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "group-header" }, "Signature", -1))
const _hoisted_20 = { class: "group-content" }
const _hoisted_21 = { class: "upload-image-section" }
const _hoisted_22 = { class: "picture-container" }
const _hoisted_23 = {
  key: 0,
  class: "displayed-file"
}
const _hoisted_24 = ["src"]
const _hoisted_25 = {
  key: 1,
  class: "fa-regular fa-image awaiting-news-image"
}
const _hoisted_26 = { class: "upload-button-disclaimer-container" }
const _hoisted_27 = {
  key: 0,
  class: "tab-fields"
}
const _hoisted_28 = { class: "sync-diary-button-pair" }
const _hoisted_29 = {
  key: 0,
  class: "tab-fields"
}

import ModalBase from "@/components/ui/modals/modal-base.vue";
import { computed, ref, inject, watch, onMounted } from "vue";
import { ModalWidth } from "@/types/ui/modals/ModalWidth";
import AcquaintTextbox from "@/components/ui/inputs/acquaint-textbox.vue";
import { FieldSize } from "@/enums/system/FieldSize";
import { UsersValidation } from "acquaint-api/validation/UsersValidation";
import { ContactsValidation } from "acquaint-api/validation/ContactsValidation";
import lookupSingleSelect from "@/components/ui/lookup/lookup-single-select.vue";
import { LookupTableSource } from "acquaint-api/constants/LookupTableSource";
import { DxToolbarItem } from "devextreme-vue/popup";
import { AcquaintApiClient } from "@/services/AcquaintApiClient";
import { getErrorMessage } from "bright-logic-core/src/errors";
import displayErrorMessage from "@/utils/ErrorHandling";
import { UserDetails } from "@/types/users/UserDetails";
import { useCurrentUserStore } from "@/stores/CurrentUserStore";
import { DxTabPanel, DxItem } from "devextreme-vue/tab-panel";
import { CurrentUser } from "@/types/user/CurrentUser";
import { AppMode } from "@/enums/system/AppMode";
import ColourPicker from "@/components/ui/inputs/colour-picker.vue";
import { UserImage } from "@/types/users/UserImage";
import { AcquaintApiNextClient } from "@/services/AcquaintApiNextClient";
import {
  convertCorrespondenceFileToBlob,
  getFileNameParts,
} from "@/utils/files/CorrespondenceFileConverter";
import FileUpload from "../../ui/inputs/file-upload.vue";
import SwitchToggle from "@/components/ui/toggles/switch-toggle.vue";
import { CodeType } from "acquaint-api/constants/CodeType";
import SystemCodeSingleSelect from "@/components/ui/system-codes/system-code-single-select.vue";
import { DxButton } from "devextreme-vue/button";
import DiaryAuthenticationModal from "@/components/diary/diary-authentication-modal.vue";
import { DiarySync } from "@/enums/diary/DiarySync";
import { standardInfoAlert } from "@/alerts/standardInfoAlert";
import { UserType } from "@/types/user/UserType";
import { UserRecordType } from "@/enums/users/UserRecordType";


export default /*#__PURE__*/_defineComponent({
  __name: 'edit-user-modal',
  props: {
  /**
   * The boolean value used with `v-model` to control the visibility or state of a modal or component.
   * @type {boolean}
   * @required
   */
  modelValue: {
    type: Boolean,
    required: true,
  },
  /**
   * The unique identifier for the user.
   * @type {number}
   * @required
   */
  userId: {
    type: Number,
    required: true,
  },
},
  emits: [
  /**
   * Triggered when the `modelValue` changes. This is used to update the v-model variable in the parent component.
   * @property {boolean} value - Indicates whether the modal has been opened or closed.
   */
  "update:modelValue",
  /**
   * Triggered when the save operation is successful.
   * This informs the parent component that the user has been saved.
   * @event saved.
   */
  "saved",
],
  setup(__props, { emit }) {

const props = __props;





const showStatusModal = computed({
  get: () => props.modelValue,
  set: (value: boolean) => emit("update:modelValue", value),
});

const acquaintApiClient = inject("AcquaintApiClient") as AcquaintApiClient;
const acquaintApiNextClient = inject(
  "AcquaintApiNextClient",
) as AcquaintApiNextClient;
const initialUserDetails = ref<UserDetails>();
const userDetails = ref<UserDetails>();
const userIsLocked = ref(false);
const keepingModalOpening = ref(false);
const currentUserStore = useCurrentUserStore();
const selectedTabPanel = ref(0);
const loggedInUser = ref<CurrentUser>();
const passwordKey = ref(0);
const displayAuthenticationModal = ref(false);
const userType = ref<UserType>();
const changesMade = ref(false);

//photo and signature variables
const resetPhotoField = ref(false);
const resetSignatureField = ref(false);
const photoToUpload = ref<File>();
const uploadedPhotoURL = ref("");
const recordPhoto = ref<UserImage>();
const signatureToUpload = ref<File>();
const uploadedSignatureURL = ref("");
const recordSignature = ref<UserImage>();
const preventEdit = ref(false);

// Code for fetching the data
onMounted(async () => {
  loggedInUser.value = await currentUserStore.getCurrentUserDetails();
});

watch(
  () => showStatusModal.value,
  async () => {
    if (!showStatusModal.value || keepingModalOpening.value) {
      return;
    }
    preventEdit.value = false;
    resetPhotoField.value = true;
    setTimeout(() => {
      resetPhotoField.value = false;
    }, 100);

    resetSignatureField.value = true;
    setTimeout(() => {
      resetSignatureField.value = false;
    }, 100);

    uploadedPhotoURL.value = "";
    uploadedSignatureURL.value = "";
    photoToUpload.value = undefined;
    signatureToUpload.value = undefined;

    // We must reset this so that the cancel confirmation modal only opens when users select the cancel
    // button after making changed
    changesMade.value = false;
    selectedTabPanel.value = 0;

    await fetchUserDetails();
    // await lockUserDetails();
    await fetchDisplayPhoto();
    await fetchDisplaySignature();

    if (!initialUserDetails.value) {
      userDetails.value = undefined;
      return;
    }

    fetchUserType(initialUserDetails.value.userTypeId);
    userDetails.value = { ...initialUserDetails.value };
  },
);

const fetchUserDetails = async () => {
  try {
    initialUserDetails.value = await acquaintApiClient.httpGet<UserDetails>(
      `app/user/record/${props.userId}`,
    );
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
    initialUserDetails.value = undefined;
  }
};

const fetchUserType = async (userId: number) => {
  try {
    userType.value = await acquaintApiClient.httpGet(
      `database/usertypes/${userId}`,
    );
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
    userType.value = undefined;
  }
};

const fetchDisplaySignature = async () => {
  await fetchSignature();

  if (!recordSignature.value || !recordSignature.value.file) {
    uploadedSignatureURL.value = "";
    return;
  }

  const fileName = getFileNameParts(
    recordSignature.value.file.fileDownloadName,
  );
  if (fileName) {
    signatureToUpload.value = new File(
      [convertCorrespondenceFileToBlob(recordSignature.value.file)],
      fileName.nameWithExtension,
      { type: recordSignature.value.file.contentType },
    );
    uploadedSignatureURL.value = window.URL.createObjectURL(
      signatureToUpload.value,
    );
  }
};

const fetchSignature = async () => {
  try {
    recordSignature.value = await acquaintApiNextClient.httpGet(
      `Users/${props.userId}/Signature`,
    );
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
    recordPhoto.value = undefined;
  }
};

const fetchDisplayPhoto = async () => {
  await fetchPhoto();

  if (!recordPhoto.value || !recordPhoto.value.file) {
    uploadedPhotoURL.value = "";
    return;
  }

  const fileName = getFileNameParts(recordPhoto.value.file.fileDownloadName);
  if (fileName) {
    photoToUpload.value = new File(
      [convertCorrespondenceFileToBlob(recordPhoto.value.file)],
      fileName.nameWithExtension,
      { type: recordPhoto.value.file.contentType },
    );
    uploadedPhotoURL.value = window.URL.createObjectURL(photoToUpload.value);
  }
};

const fetchPhoto = async () => {
  try {
    recordPhoto.value = await acquaintApiNextClient.httpGet(
      `Users/${props.userId}/Photo`,
    );
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
    recordPhoto.value = undefined;
  }
};

// Code for submitting the data
const submitData = async () => {
  try {
    userDetails.value = await acquaintApiClient.httpPost<UserDetails>(
      `app/user/record/${props.userId}`,
      userDetails.value,
    );
    return true;
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
    return false;
  }
};

const onSaveClick = async (e: any) => {
  const validate = e.validationGroup.validate();

  // Avoid unnecessary api calls if form is invalid
  if (!validate.isValid || !userDetails.value) {
    return;
  }

  if (photoToUpload.value) {
    await uploadPhoto();
    userDetails.value.photo = photoToUpload.value.name;
  } else {
    userDetails.value.photo = "";
  }
  if (signatureToUpload.value) {
    await uploadSignature();
    userDetails.value.signature = signatureToUpload.value.name;
  } else {
    userDetails.value.signature = "";
  }
  await lockUserDetails();
  if (userIsLocked.value) return;

  // Save wasn't sucessful, so allow user to retry / correct errors
  if (!(await submitData())) {
    return;
  }

  // To avoid invalid database connection tokens, we must generate a new token
  if ((await editingLoggedInUser()) && userDetails.value?.password) {
    acquaintApiClient.RefreshDatabaseConnectionToken(
      userDetails.value.password,
    );
  }

  changesMade.value = false;
  showStatusModal.value = false;
  setTimeout(() => {
    emit("saved");
  }, 500);
};

const uploadPhoto = async () => {
  try {
    await acquaintApiClient.uploadFile(
      `app/user/${userDetails.value?.id}/photo`,
      photoToUpload.value,
    );
    return true;
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
    return false;
  }
};

const uploadSignature = async () => {
  try {
    await acquaintApiClient.uploadFile(
      `app/user/${userDetails.value?.id}/signature`,
      signatureToUpload.value,
    );
    return true;
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
    return false;
  }
};

const editingLoggedInUser = async () => {
  return props.userId === loggedInUser.value?.id;
};

// Locking code
const lockUserDetails = async () => {
  try {
    await acquaintApiClient.httpPostVoid(
      `database/users/${props.userId}/lock`,
      {
        lock: true,
        extraInfo: "",
      },
    );
    userIsLocked.value = false;
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
    userIsLocked.value = true;
  }
};

const unLockUserDetails = async () => {
  try {
    await acquaintApiClient.httpPostVoid(
      `database/users/${props.userId}/lock`,
      {
        lock: false,
        extraInfo: "",
      },
    );
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
  }
};

// Code for handling photo and signature uploads
const photoAddedOrUpdated = (e: File[]) => {
  if (!e || e.length == 0) {
    photoToUpload.value = undefined;
    uploadedPhotoURL.value = "";
    return;
  }

  photoToUpload.value = e[0];
  uploadedPhotoURL.value = window.URL.createObjectURL(e[0]);
};

const signatureAddedOrUpdated = (e: File[]) => {
  if (!e || e.length == 0) {
    signatureToUpload.value = undefined;
    uploadedSignatureURL.value = "";
    return;
  }

  signatureToUpload.value = e[0];
  uploadedSignatureURL.value = window.URL.createObjectURL(e[0]);
};

// Diary Sync Code
const authenticateDiary = async () => {
  preventEdit.value = false;
  displayAuthenticationModal.value = true;
};

const diaryAuthenticationModalClosed = (authenticationSuccessful: boolean) => {
  if (preventEdit.value || !userDetails.value) {
    return;
  }

  if (authenticationSuccessful) {
    preventEdit.value = true;
    return;
  }

  standardInfoAlert("Authentication failed. Please try again.");
  userDetails.value.syncDiary = DiarySync.None;
  preventEdit.value = false;
};

// If the user is a system administrator, they can manage the branch manager toggle
const enableManagerToggle = computed(() => {
  return (
    userType.value?.systemAdministrator == UserRecordType.SystemAdministrator
  );
});

watch(
  () => userDetails.value?.userTypeId,
  async () => {
    if (!userDetails.value) {
      return;
    }

    await fetchUserType(userDetails.value.userTypeId);

    if (!enableManagerToggle.value) {
      userDetails.value.branchManager = false;
    }
  },
);

// Code relating to the closing of the modal
const onCancelClick = () => {
  showStatusModal.value = false;
};

watch(
  () => userDetails.value,
  (value) => {
    changesMade.value =
      JSON.stringify(value) != JSON.stringify(initialUserDetails.value);
  },
  { deep: true },
);

const modalClosed = () => {
  unLockUserDetails();
  keepingModalOpening.value = false;

  // Increment password key to reset password mask
  passwordKey.value++;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ModalBase, {
      modelValue: showStatusModal.value,
      "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((showStatusModal).value = $event)),
      title: "User",
      width: _unref(ModalWidth).Small,
      height: "770px",
      "show-close-confirmation-prompt": changesMade.value,
      onModalClosed: modalClosed,
      onCancelPromptDenied: _cache[27] || (_cache[27] = ($event: any) => (keepingModalOpening.value = true))
    }, {
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_unref(DxTabPanel), {
            selectedIndex: selectedTabPanel.value,
            "onUpdate:selectedIndex": _cache[25] || (_cache[25] = ($event: any) => ((selectedTabPanel).value = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(DxItem), { title: "General" }, {
                default: _withCtx(() => [
                  (userDetails.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createElementVNode("div", null, [
                          _createElementVNode("div", _hoisted_3, [
                            _createVNode(AcquaintTextbox, {
                              label: "First Name",
                              modelValue: userDetails.value.firstNames,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((userDetails.value.firstNames) = $event)),
                              fieldValidation: _unref(ContactsValidation).FirstNames,
                              width: _unref(FieldSize).Full,
                              readOnly: userIsLocked.value,
                              "validation-group": "edit-user-modal"
                            }, null, 8, ["modelValue", "fieldValidation", "width", "readOnly"]),
                            _createVNode(AcquaintTextbox, {
                              label: "Username",
                              modelValue: userDetails.value.username,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((userDetails.value.username) = $event)),
                              fieldValidation: _unref(UsersValidation).UserName,
                              width: _unref(FieldSize).Full,
                              readOnly: userIsLocked.value,
                              "validation-group": "edit-user-modal"
                            }, null, 8, ["modelValue", "fieldValidation", "width", "readOnly"]),
                            _createVNode(AcquaintTextbox, {
                              label: "Last Name",
                              modelValue: userDetails.value.lastName,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((userDetails.value.lastName) = $event)),
                              fieldValidation: _unref(ContactsValidation).LastName,
                              width: _unref(FieldSize).Full,
                              readOnly: userIsLocked.value,
                              "validation-group": "edit-user-modal"
                            }, null, 8, ["modelValue", "fieldValidation", "width", "readOnly"]),
                            (_openBlock(), _createBlock(AcquaintTextbox, {
                              label: "Password",
                              modelValue: userDetails.value.password,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((userDetails.value.password) = $event)),
                              fieldValidation: _unref(UsersValidation).Password,
                              width: _unref(FieldSize).Full,
                              readOnly: userIsLocked.value,
                              "validation-group": "edit-user-modal",
                              key: passwordKey.value
                            }, null, 8, ["modelValue", "fieldValidation", "width", "readOnly"])),
                            _createVNode(lookupSingleSelect, {
                              label: "Title",
                              modelValue: userDetails.value.title,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((userDetails.value.title) = $event)),
                              "lookup-source": _unref(LookupTableSource).Titles,
                              width: _unref(FieldSize).Full,
                              readOnly: userIsLocked.value
                            }, null, 8, ["modelValue", "lookup-source", "width", "readOnly"]),
                            _createVNode(lookupSingleSelect, {
                              label: "Branch",
                              "lookup-source": _unref(LookupTableSource).Sites,
                              modelValue: userDetails.value.siteID,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((userDetails.value.siteID) = $event)),
                              width: _unref(FieldSize).Full,
                              readOnly: userIsLocked.value,
                              "allow-zero-value": true
                            }, null, 8, ["lookup-source", "modelValue", "width", "readOnly"]),
                            _createVNode(AcquaintTextbox, {
                              label: "Email",
                              modelValue: userDetails.value.email,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((userDetails.value.email) = $event)),
                              fieldValidation: _unref(ContactsValidation).Email,
                              width: _unref(FieldSize).Full,
                              readOnly: userIsLocked.value,
                              "validation-group": "edit-user-modal"
                            }, null, 8, ["modelValue", "fieldValidation", "width", "readOnly"]),
                            _createVNode(lookupSingleSelect, {
                              label: "Status",
                              "lookup-source": _unref(LookupTableSource).Statuses,
                              modelValue: userDetails.value.statusID,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((userDetails.value.statusID) = $event)),
                              width: _unref(FieldSize).Full,
                              readOnly: userIsLocked.value
                            }, null, 8, ["lookup-source", "modelValue", "width", "readOnly"]),
                            _createVNode(AcquaintTextbox, {
                              label: "Mobile",
                              modelValue: userDetails.value.mobileTelephone,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((userDetails.value.mobileTelephone) = $event)),
                              fieldValidation: _unref(ContactsValidation).MobileTelephone,
                              width: _unref(FieldSize).Full,
                              readOnly: userIsLocked.value
                            }, null, 8, ["modelValue", "fieldValidation", "width", "readOnly"]),
                            _createVNode(lookupSingleSelect, {
                              label: "Type",
                              "lookup-source": _unref(LookupTableSource).UserTypes,
                              modelValue: userDetails.value.userTypeId,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((userDetails.value.userTypeId) = $event)),
                              width: _unref(FieldSize).Full,
                              readOnly: userIsLocked.value
                            }, null, 8, ["lookup-source", "modelValue", "width", "readOnly"]),
                            _createVNode(SwitchToggle, {
                              modelValue: userDetails.value.branchManager,
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((userDetails.value.branchManager) = $event)),
                              label: "Branch Manager",
                              "label-width": "6rem",
                              readOnly: userIsLocked.value || !enableManagerToggle.value
                            }, null, 8, ["modelValue", "readOnly"])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_unref(DxItem), {
                title: "Advanced",
                visible: _unref(AppMode).Full == loggedInUser.value?.appMode
              }, {
                default: _withCtx(() => [
                  (userDetails.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                          _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("div", _hoisted_7, [
                              _createVNode(SwitchToggle, {
                                modelValue: userDetails.value.allowSignatoryChange,
                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((userDetails.value.allowSignatoryChange) = $event)),
                                label: "Signatory Change",
                                "label-width": "15rem",
                                readOnly: userIsLocked.value
                              }, null, 8, ["modelValue", "readOnly"]),
                              _createVNode(lookupSingleSelect, {
                                label: "Department",
                                "lookup-source": _unref(LookupTableSource).UserDepartments,
                                modelValue: userDetails.value.departmentId,
                                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((userDetails.value.departmentId) = $event)),
                                width: _unref(FieldSize).Full,
                                "read-only": userIsLocked.value
                              }, null, 8, ["lookup-source", "modelValue", "width", "read-only"])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", null, [
                          _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("div", _hoisted_9, [
                              _hoisted_10,
                              _createElementVNode("div", _hoisted_11, [
                                _createElementVNode("section", _hoisted_12, [
                                  _createElementVNode("div", _hoisted_13, [
                                    (uploadedPhotoURL.value != '')
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                          _createElementVNode("img", { src: uploadedPhotoURL.value }, null, 8, _hoisted_15)
                                        ]))
                                      : (_openBlock(), _createElementBlock("i", _hoisted_16))
                                  ]),
                                  _createElementVNode("div", _hoisted_17, [
                                    _createVNode(FileUpload, {
                                      width: "300px",
                                      text: "Upload",
                                      fileTypes: ".jpg",
                                      reset: resetPhotoField.value,
                                      multiple: false,
                                      onFilesChanged: photoAddedOrUpdated,
                                      "read-only": userIsLocked.value,
                                      "show-file-list": true,
                                      defaultFiles: photoToUpload.value ? [photoToUpload.value] : []
                                    }, null, 8, ["reset", "read-only", "defaultFiles"])
                                  ])
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_18, [
                              _hoisted_19,
                              _createElementVNode("div", _hoisted_20, [
                                _createElementVNode("section", _hoisted_21, [
                                  _createElementVNode("div", _hoisted_22, [
                                    (uploadedSignatureURL.value != '')
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                          _createElementVNode("img", { src: uploadedSignatureURL.value }, null, 8, _hoisted_24)
                                        ]))
                                      : (_openBlock(), _createElementBlock("i", _hoisted_25))
                                  ]),
                                  _createElementVNode("div", _hoisted_26, [
                                    _createVNode(FileUpload, {
                                      width: "300px",
                                      text: "Upload",
                                      fileTypes: ".jpg",
                                      reset: resetSignatureField.value,
                                      multiple: false,
                                      onFilesChanged: signatureAddedOrUpdated,
                                      "read-only": userIsLocked.value,
                                      "show-file-list": true,
                                      defaultFiles: 
                              signatureToUpload.value ? [signatureToUpload.value] : []
                            
                                    }, null, 8, ["reset", "read-only", "defaultFiles"])
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["visible"]),
              _createVNode(_unref(DxItem), { title: "Diary" }, {
                default: _withCtx(() => [
                  (userDetails.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                        _createElementVNode("div", _hoisted_28, [
                          _createVNode(SystemCodeSingleSelect, {
                            label: "Sync. Diary",
                            modelValue: userDetails.value.syncDiary,
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((userDetails.value.syncDiary) = $event)),
                            "code-type": _unref(CodeType).SyncDiary,
                            idsToExclude: [_unref(DiarySync).Outlook],
                            width: _unref(FieldSize).Medium
                          }, null, 8, ["modelValue", "code-type", "idsToExclude", "width"]),
                          (userDetails.value.syncDiary != _unref(DiarySync).None)
                            ? (_openBlock(), _createBlock(_unref(DxButton), {
                                key: 0,
                                text: "Authenticate",
                                onClick: authenticateDiary
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _createVNode(SystemCodeSingleSelect, {
                          label: "Sync. Diary Level",
                          modelValue: userDetails.value.syncDiaryLevel,
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((userDetails.value.syncDiaryLevel) = $event)),
                          "code-type": _unref(CodeType).DiarySyncLevel,
                          width: _unref(FieldSize).Medium
                        }, null, 8, ["modelValue", "code-type", "width"]),
                        _createVNode(ColourPicker, {
                          label: "Text Colour",
                          modelValue: userDetails.value.foreColor,
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((userDetails.value.foreColor) = $event)),
                          readOnly: false
                        }, null, 8, ["modelValue"]),
                        _createVNode(ColourPicker, {
                          label: "Background Colour",
                          modelValue: userDetails.value.backColor,
                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((userDetails.value.backColor) = $event)),
                          readOnly: false
                        }, null, 8, ["modelValue"])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_unref(DxItem), { title: "Show Reminders" }, {
                default: _withCtx(() => [
                  (userDetails.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                        _createVNode(SwitchToggle, {
                          modelValue: userDetails.value.showSystemReminders,
                          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((userDetails.value.showSystemReminders) = $event)),
                          label: "System",
                          "label-width": "15rem",
                          readOnly: userIsLocked.value
                        }, null, 8, ["modelValue", "readOnly"]),
                        _createVNode(SwitchToggle, {
                          modelValue: userDetails.value.showContactReminders,
                          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((userDetails.value.showContactReminders) = $event)),
                          label: "Contacts",
                          "label-width": "15rem",
                          readOnly: userIsLocked.value
                        }, null, 8, ["modelValue", "readOnly"]),
                        _createVNode(SwitchToggle, {
                          modelValue: userDetails.value.showAppointmentReminders,
                          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((userDetails.value.showAppointmentReminders) = $event)),
                          label: "Appointments",
                          "label-width": "15rem",
                          readOnly: userIsLocked.value
                        }, null, 8, ["modelValue", "readOnly"]),
                        _createVNode(SwitchToggle, {
                          modelValue: userDetails.value.showFinancialReminders,
                          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((userDetails.value.showFinancialReminders) = $event)),
                          label: "Financial",
                          "label-width": "15rem",
                          readOnly: userIsLocked.value
                        }, null, 8, ["modelValue", "readOnly"]),
                        _createVNode(SwitchToggle, {
                          modelValue: userDetails.value.showPropertySalesReminders,
                          "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((userDetails.value.showPropertySalesReminders) = $event)),
                          label: "Property Sales",
                          "label-width": "15rem",
                          readOnly: userIsLocked.value
                        }, null, 8, ["modelValue", "readOnly"]),
                        _createVNode(SwitchToggle, {
                          modelValue: userDetails.value.showPropertyLettingsReminders,
                          "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((userDetails.value.showPropertyLettingsReminders) = $event)),
                          label: "Property Lettings",
                          "label-width": "15rem",
                          readOnly: userIsLocked.value
                        }, null, 8, ["modelValue", "readOnly"]),
                        _createVNode(SwitchToggle, {
                          modelValue: userDetails.value.showPropertyManagementReminders,
                          "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((userDetails.value.showPropertyManagementReminders) = $event)),
                          label: "Property Management",
                          "label-width": "15rem",
                          readOnly: userIsLocked.value
                        }, null, 8, ["modelValue", "readOnly"]),
                        _createVNode(SwitchToggle, {
                          modelValue: userDetails.value.showCertificatesReminders,
                          "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((userDetails.value.showCertificatesReminders) = $event)),
                          label: "Certificates",
                          "label-width": "15rem",
                          readOnly: userIsLocked.value
                        }, null, 8, ["modelValue", "readOnly"])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["selectedIndex"])
        ])
      ]),
      footer: _withCtx(() => [
        _createVNode(_unref(DxToolbarItem), {
          widget: "dxButton",
          toolbar: "bottom",
          location: "after",
          options: {
          text: 'Save',
          onClick: (e) => {
            onSaveClick(e);
          },
          validationGroup: 'edit-user-modal',
        }
        }, null, 8, ["options"]),
        _createVNode(_unref(DxToolbarItem), {
          widget: "dxButton",
          toolbar: "bottom",
          location: "after",
          options: {
          text: 'Cancel',
          onClick: () => {
            onCancelClick();
          },
        }
        }, null, 8, ["options"])
      ]),
      _: 1
    }, 8, ["modelValue", "width", "show-close-confirmation-prompt"]),
    _createVNode(DiaryAuthenticationModal, {
      modelValue: displayAuthenticationModal.value,
      "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((displayAuthenticationModal).value = $event)),
      "user-id": props.userId,
      diarySyncType: userDetails.value?.syncDiary ?? 0,
      onModalClosed: diaryAuthenticationModalClosed
    }, null, 8, ["modelValue", "user-id", "diarySyncType"])
  ], 64))
}
}

})